import { supportedLanguages } from '../../static/supportedLanguages';

export const getLangCode = (language: string) => {
  const lang = supportedLanguages.find(lang => lang.id === language || lang.locale === language)?.id as string;

  return lang ?? 'pl';
};
